import { renderDocFlowSendingTableCell } from '../../DocFlowSendingTableRow'
import { DocFlowCommunicationStatusCell } from '../DocFlowCommunicationStatusCell'
import { DocFlowSendingFieldName } from '../DocFlowSending.constants'

function getCommunicationStatus(t) {
  return {
    text: t('DocumentStapling.SendingResultOnStatusTextKey'),
    textColor: 'var(--secondary-text-color)',
  }
}

function getCommunicationStatusEmail(t) {
  return {
    text: t('DocumentStapling.SendingResultLinkStatusTextKey'),
    textColor: 'var(--secondary-text-color)',
    tooltip: t('DocumentStapling.SendingResultLinkStatusTooltipKey'),
  }
}

function getEmailStatuses({ isLink, t }) {
  return isLink
    ? [getCommunicationStatus(t), getCommunicationStatusEmail(t)]
    : [getCommunicationStatusEmail(t)]
}

export function renderCell({ item, name, scrollRef, t, ...restProps }) {
  const { [name]: value } = item

  switch (name) {
    case DocFlowSendingFieldName.SaveToProfile:
      return (
        <DocFlowCommunicationStatusCell
          {...restProps}
          items={[getCommunicationStatus(t)]}
          value={value}
        />
      )

    case DocFlowSendingFieldName.SendEmail:
      return (
        <DocFlowCommunicationStatusCell
          {...restProps}
          items={getEmailStatuses({ t })}
          tooltip={t('DocFlow.SendingResultLinkStatusTooltipKey')}
          value={value}
        />
      )

    case DocFlowSendingFieldName.SendAdditionalEmail:
      return (
        <DocFlowCommunicationStatusCell
          {...restProps}
          items={getEmailStatuses({ t })}
          tooltip={t('DocFlow.SendingResultLinkStatusTooltipKey')}
          value={value}
        />
      )

    case DocFlowSendingFieldName.SendEpost:
      return (
        <DocFlowCommunicationStatusCell
          {...restProps}
          items={[getCommunicationStatus(t)]}
          tooltip={t('DocFlow.SendingResultLinkStatusTooltipKey')}
          value={value}
        />
      )

    default:
      return renderDocFlowSendingTableCell({
        item,
        name,
        scrollRef,
        t,
        ...restProps,
      })
  }
}
